module.exports = __webpack_public_path__ + "static/RC_Contabilidade-1202469301218e9529b7a6d96d3c736b.png";